{
	"content": {
		"declarationDetailsSection": {
			"title": "Declaration details",
			"description": "To create the declaration the customer name, address and country of the declaration holder is needed. The information cannot be changed afterwards.",
			"customerLabel": "Customer account"
		},
		"provideDeclarationsDetailsSection": {
			"title": "Provide declaration details",
			"alertDescription": "The information you provide will be permanently recorded on the declaration and cannot be modified afterwards.",
			"projectLabel": "Project reference",
			"companyNameLabel": "Company name",
			"streetLabel": "Street",
			"zipCodeLabel": "Zip code",
			"cityLabel": "City",
			"countryLabel": "Country"
		}
	},
	"summary": {
		"title": "Summary",
		"declarationTypeTitle": "Declaration type",
		"customerProjectTitle": "Customer project",
		"internalProjectOrProductTitle": "Internal project / product",
		"projectReferenceTitle": "Project reference",
		"materialHeaderTitle": "Material",
		"quantityHeaderTitle": "Quantity ({{unit}})",
		"totalTransferableCarbonReductionsTitle": "Allocatable carbon reductions ({{unit}})",
		"nonTransferableCarbonReductionTitle": "Non-allocatable carbon reduction ({{unit}})"
	},
	"errorMessages": {
		"projectRequired": "Project reference is required",
		"companyNameRequired": "Company name is required",
		"streetRequired": "Street is required",
		"zipCodeRequired": "Zip code is required",
		"cityRequired": "City is required",
		"countryRequired": "Country is required",
		"customerRequired": "Customer is required"
	},
	"reviewDeclarationDetailsModal": {
		"title": "Review declaration summary",
		"description": "Please review the data you have entered for any mistakes.",
		"alertDescription": "The information you have provided will be permanently recorded on the declaration and cannot be modified afterwards.",
		"typeSectionTitle": "1. Type",
		"declarationTypeLabel": "Declaration type",
		"customerProjectTitle": "Customer project",
		"internalProjectOrProductTitle": "Internal project / product",
		"projectReferenceLabel": "Project reference",
		"materialSectionTitle": "2. Material",
		"materialHeaderTitle": "Material",
		"quantityHeaderTitle": "Quantity ({{unit}})",
		"totalCarbonReductionsLabel": "Total carbon reductions ({{unit}})",
		"declarationSectionTitle": "3. Declaration",
		"companyNameLabel": "Company name",
		"streetLabel": "Street",
		"zipCodeLabel": "Zip code",
		"cityLabel": "City",
		"countryLabel": "Country",
		"backTitle": "Back",
		"submitTitle": "Yes, everything is correct"
	},
	"submitTitle": "Create declaration",
	"backTitle": "Back"
}
